import React from "react";
import Page, { PageProps } from "../Page";
import { ILoginPresenter } from "../../../presenter/authentication/LoginPresenter";
import LoginForm from "./LoginForm";

export interface Props extends PageProps {}
export interface State extends ILoginPresenter {}

export default class LoginPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      login,
      username,
      password,
      loginButtonDisabled,
      setUsername,
      setPassword,
      application
    } = this.state;

    return (
      <Page
        {...this.props}
        style={{
          display: "flex",
          justifyContent: "center",
          height: "100%",
          width: "100%"
        }}
      >
        <LoginForm
          router={this.props.router}
          translate={translate}
          username={username}
          password={password}
          login={login}
          loginButtonDisabled={loginButtonDisabled}
          onChangePassword={setPassword}
          onChangeUsername={setUsername}
          loading={this.state.loaders.loginLoader}
          title={application.applicationName}
        />
      </Page>
    );
  }
}
